import axios from "axios";
import { LOGOUT_URL } from "App/constants";

export const logout = async () => {
  await axios.delete(`${LOGOUT_URL}`);
};
